import { FC } from 'react'
import { CreditCardFloatingPane } from 'components/features/creditCard/creditCardStore/floatingPane'
import AddPaymentMethodPane from 'components/features/creditCard/creditCardPanes/AddPaymentMethodPane'
import BalanceDetailsPane from 'components/features/creditCard/creditCardPanes/BalanceDetailsPane'
import CardDetailsPane from 'components/features/creditCard/creditCardPanes/CardDetailsPane'
import CardMenuPane from 'components/features/creditCard/creditCardPanes/CardMenuPane'
import CardPaymentsPane from 'components/features/creditCard/creditCardPanes/CardPaymentsPane'
import ChangePinPane from 'components/features/creditCard/creditCardPanes/ChangePinPane'
import CreditCardSignupPane from 'components/features/creditCard/creditCardLanding/CreditCardSignupPane/CreditCardSignupPane'
import LockCardPane from 'components/features/creditCard/creditCardPanes/LockCardPane'
import PayCardPane from 'components/features/creditCard/creditCardPanes/PayCardPane/PayCardPane'
import PaymentMethodsPane from 'components/features/creditCard/creditCardPanes/PaymentMethodsPane'
import ReplaceCardPane from 'components/features/creditCard/creditCardPanes/ReplaceCardPane'
import YourStatementsPane from 'components/features/creditCard/creditCardPanes/YourStatementsPane'
import CardTermsPane from 'components/features/creditCard/creditCardPanes/CardTermsPane'

type CreditCardPaneHostProps = {
  pane: CreditCardFloatingPane
}

export const CreditCardPaneHost: FC<CreditCardPaneHostProps> = ({ pane }) => {

  switch (pane?.mode) {
    case 'signup':
      return <CreditCardSignupPane { ...pane } />

    case 'cardMenu': {
      return <CardMenuPane />
    }

    case 'terms': {
      return <CardTermsPane />
    }

    case 'cardDetails': {
      return <CardDetailsPane />
    }

    case 'paymentMethods': {
      return <PaymentMethodsPane />
    }

    case 'addPaymentMethod': {
      return <AddPaymentMethodPane />
    }

    case 'autoPay':
    case 'payCard': {
      return <PayCardPane { ...pane } />
    }

    case 'changePin': {
      return <ChangePinPane />
    }

    case 'replaceCard': {
      return <ReplaceCardPane step={ pane.step } reason={ pane.reason } />
    }

    case 'lockOrUnlock': {
      return <LockCardPane />
    }

    case 'payments': {
      return <CardPaymentsPane />
    }

    case 'statements': {
      return <YourStatementsPane />
    }

    case 'balance': {
      return <BalanceDetailsPane />
    }
  }

  return null
}
